import axios from "axios";
import jwtInterceptor from "../interceptors/SetAuthToken";

const AUTH_API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/auth";

class AuthService {
  getAccounts(params) {
    return jwtInterceptor.get(AUTH_API_BASE_URL, { params });
  }

  login(payload) {
    return axios.post(AUTH_API_BASE_URL + "/authenticate", payload);
  }

  refreshToken(token) {
    return axios.post(AUTH_API_BASE_URL + "/refresh-token", {
      refreshToken: token,
    });
  }

  forgotPassword(data) {
    return axios.post(AUTH_API_BASE_URL + "/forgot-password", data);
  }
}

export default new AuthService();
